import React, {
    FC, useCallback, useMemo, useState,
} from 'react';
import { useSecure } from 'libs/additiv-react-oidc-client';
import ActivityDetector from 'react-activity-detector';
import { ModalLogout } from './components/ModalLogout';
import { useAuth } from '../hooks/useAuth';
import { AutoLogoutProps } from './AutoLogoutProps.types';

const AutoLogout: FC<AutoLogoutProps> = (props) => {
    const { config } = props;
    const { signinSilent } = useSecure();
    const { logout } = useAuth();
    const [showModal, setShowModal] = useState(false);

    const showAutoLogoutModal = useCallback(() => {
        if (showModal) { return; }
        setShowModal(true);
    }, [showModal]);

    // Convert userInactiveTimeout from seconds to milliseconds
    const userInactiveTimeout = useMemo(() => 1000 * (config.userInactiveTimeout ?? 3600), [config.userInactiveTimeout]);
    const onIdle = () => { showAutoLogoutModal(); };

    // No `onActive` handler on purpose. `react-activity-detector` calls it from the raw
    // mousemove/click/keydown listener with no idle->active transition guard, so anything non-trivial
    // in there runs on every mouse movement. Token renewal is handled by `automaticSilentRenew`.

    return (
        <>
            <ActivityDetector enabled timeout={userInactiveTimeout} onIdle={onIdle} name="default" />
            <ModalLogout
                dialogCountdown={config.dialogCountDownTimeout}
                visible={showModal}
                onContinue={() => {
                    setShowModal(false);
                    signinSilent();
                }}
                onTimeOver={() => {
                    setShowModal(false);
                    logout();
                }}
            />
        </>
    );
};

export default AutoLogout;
